// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

/** English UI strings: the formatting bar, tables, and canvases. Merged into the catalog by messages.en.ts. */
export const editorTools = {
  "format.bar": "Formatting",
  "format.bold": "Bold",
  "format.italic": "Italic",
  "format.strike": "Strikethrough",
  "format.highlight": "Highlight",
  "format.code": "Inline code",
  "format.heading": "Heading (cycles H1, H2, H3)",
  "format.bullets": "Bulleted list",
  "format.numbers": "Numbered list",
  "format.task": "Task",
  "format.quote": "Quote",
  "format.wikilink": "Link to a note",
  "format.link": "Web link",
  "format.codeBlock": "Code block",
  "format.rule": "Divider",
  "format.table.insert": "Insert table",
  "format.table.size": "{rows} × {cols}",
  "format.table.tools": "Table",
  "format.table.addRow": "+ Row",
  "format.table.addColumn": "+ Column",
  "format.table.deleteRow": "− Row",
  "format.table.deleteColumn": "− Column",
  "format.table.alignLeft": "Align left",
  "format.table.alignCenter": "Center",
  "format.table.alignRight": "Align right",
  "format.toggleBar": "Toggle formatting bar",

  "canvas.new": "New canvas",
  "canvas.newInFolder": "New canvas in folder",
  "canvas.label": "Canvas {name}",
  "canvas.toolbar": "Canvas tools",
  "canvas.addCard": "Add card",
  "canvas.addNote": "Add note",
  "canvas.addLink": "Add web page",
  "canvas.addGroup": "Add group",
  "canvas.delete": "Delete selected",
  "canvas.zoomIn": "Zoom in",
  "canvas.zoomOut": "Zoom out",
  "canvas.fit": "Zoom to fit",
  "canvas.color": "Color",
  "canvas.noColor": "No color",
  "canvas.pickNote": "Choose a note",
  "canvas.filter": "Find a note",
  "canvas.noNotes": "No notes match.",
  "canvas.linkPrompt": "Web address",
  "canvas.newCard": "New card",
  "canvas.newGroup": "Group",
  "canvas.missing": "{path} is not in this vault.",
  "canvas.invalid": "This canvas file could not be read. Fix it as text, or start over.",
  "canvas.editAsText": "Edit as text",
  "canvas.startOver": "Start an empty canvas",
  "canvas.hint": "Double-click to add a card. Drag from a card's edge dot to connect. Drag the background to move; scroll or pinch to zoom.",
  "canvas.edgeLabel": "Label",
  "canvas.empty": "This canvas is empty.",
  "canvas.node": "Card {n}",
  "canvas.open": "Open",
  "canvas.hintTouch": "Double-tap to add a card, and a card to write in it. Drag from a card's edge dot to connect. Drag the background to move; pinch to zoom.",
  "canvas.undo": "Undo",
  "canvas.redo": "Redo",
  "canvas.role": "canvas",
} as const;
